import React from 'react';

import { images } from '../../constants';
import './AboutUs.css';

const AboutUs = () => (
  <div className='app__aboutus app__bg flex__center section__padding' id='about'>
    <div className='app__aboutus-overlay flex__center'>
      <img src={images.P} alt='two p letters' />
    </div>
    <div className='app__aboutus-content flex__center'>
      <div className='app__aboutus-content_about'>
        <h1 className='headtext__cormorant'>About Us</h1>
        <img src={images.spoon} alt='about_spoon' className='spoon__img' />
        <p>Welcome to Paul's Place, where we bring together the best of food, service, and atmosphere to create an unforgettable dining experience. Our menu is a reflection of our passion for food, featuring a diverse selection of dishes that are sure to please every palate. Our service is second to none, with servers who are knowledgeable and attentive, providing a seamless dining experience that leaves nothing to be desired. We pride ourselves on creating a warm and welcoming atmosphere, where guests can relax and enjoy their meal in comfort. Whether you're celebrating a special occasion, looking for a romantic dinner spot or simply want to enjoy a delicious meal, we look forward to serving you soon.</p>
      </div>
      <div className='app__aboutus-content_knife flex__center'>
        <img src={images.knife} alt='about_knife' />
      </div>
      <div className='app__aboutus-content_history'>
        <h1 className='headtext__cormorant'>Our History</h1>
        <img src={images.spoon} alt='about_spoon' className='spoon__img' />
        <p>Lorem ipsum odor amet, consectetuer adipiscing elit. Ac purus in massa egestas mollis varius;
          dignissim elementum. Mollis tincidunt mattis hendrerit dolor eros enim, nisi ligula ornare.
          Hendrerit parturient habitant pharetra rutrum gravida porttitor eros feugiat. Mollis elit
          sodales taciti duis praesent id. Consequat urna vitae morbi nunc congue.</p>
      </div>
    </div>
  </div>
);

export default AboutUs;
